import { POSSource } from '@app/domain/pos/POSSource'
import { POSTableMappingItem } from '@app/domain/pos/POSTableMappingItem'

export class POSConfiguration {
    constructor(
        public id: string,
        public isEnabled: boolean,
        public source: POSSource,
        public apiBaseUrl: string,
        public databaseName: string,
        public username: string,
        public posUserId: string,
        public password: string | null,
        public tableMappings: POSTableMappingItem[] | null,
        public onlyPushDepositBookings: boolean = false
    ) {
    }
}
